import React, { useState, useEffect } from 'react';
import FeedbackModal from '../FeedbackModal/FeedbackModal';
import { API_ENDPOINTS } from '../../config/api';
import './Footer.css';

const Footer: React.FC = () => {
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);
  const [isBackendHealthy, setIsBackendHealthy] = useState<boolean | null>(null);
  const [version, setVersion] = useState('5.1');
  const [deployTime, setDeployTime] = useState<string | null>(null);

  useEffect(() => {
    const checkHealth = async () => {
      try {
        const response = await fetch(API_ENDPOINTS.HEALTH);
        setIsBackendHealthy(response.ok);
      } catch (error) {
        setIsBackendHealthy(false);
      }
    };

    checkHealth();
    // Check every 30 seconds
    const interval = setInterval(checkHealth, 30000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    fetch('/version.txt')
      .then((r) => r.text())
      .then((text) => {
        if (text && text.trim()) {
          setVersion(text.trim());
        }
      })
      .catch(() => {});

    fetch('/deploy-time.txt')
      .then((r) => r.text())
      .then((text) => {
        if (text && text.trim()) {
          const date = new Date(text.trim());
          if (!isNaN(date.getTime())) {
            const formatted = new Intl.DateTimeFormat('en-US', {
              dateStyle: 'medium',
              timeStyle: 'short',
            }).format(date);
            setDeployTime(formatted);
          } else {
            setDeployTime(text.trim());
          }
        }
      })
      .catch(() => {});
  }, []);

  return (
    <>
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="footer-icons">
              <a href="/terms" className="footer-icon" title="Terms of Service">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </a>
              <a href="/privacy" className="footer-icon" title="Privacy Policy">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </a>
              <a href="mailto:admin@usublease.com" className="footer-icon footer-icon--mail" title="Contact Us">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M3 7L12 13L21 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </a>
              <button
                className="footer-icon"
                onClick={() => setIsFeedbackModalOpen(true)}
                title="Help & Feedback"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M9.09 9C9.3251 8.33167 9.78915 7.76811 10.4 7.40913C11.0108 7.05016 11.7289 6.91894 12.4272 7.03871C13.1255 7.15849 13.7588 7.52152 14.2151 8.06353C14.6713 8.60553 14.9211 9.29152 14.92 10C14.92 12 11.92 13 11.92 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <circle cx="12" cy="17" r="1" fill="currentColor" />
                </svg>
              </button>
              <div 
                className="footer-version-capsule"
                data-tooltip={deployTime ? `Latest deploy: ${deployTime}` : undefined}
              >
                {version}
                <span className={`status-dot ${isBackendHealthy === true ? 'healthy' : isBackendHealthy === false ? 'unhealthy' : 'unknown'}`}></span>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <FeedbackModal 
        isOpen={isFeedbackModalOpen} 
        onClose={() => setIsFeedbackModalOpen(false)} 
      />
    </>
  );
};

export default Footer;